import store from '@/store'

import Vue from 'vue'
import Echo from 'laravel-echo'

const host = process.env.CHAT_SERVER
const port = process.env.CHAT_SERVER_PORT
const provider = process.env.CHAT_PROVIDER

let tokenChat = ''
let responseStatus = ''
let authorizationResult = ''

export const EchoChat = async () => {
  await store.commit('setSetting', {
    chatUrl: host,
    chatPort: port,
    chatProvider: provider,
  })

  if (!store.state.plChat.provider.chat.token) {
    tokenChat = await store.commit('getTokenInLocalStorage', 'tokenChat')

    if (!tokenChat) {
      await store.commit('getCrmToken')

      authorizationResult = await store.dispatch('authorization')
    }
  }

  if (authorizationResult !== 'ok') {
    Vue.notify({
      group: 'hasBottomNavigation',
      title: `Ошибка авторизации в сервисе чата`,
      type: 'error',
      text: authorizationResult?.message || authorizationResult?.status || 'Сервер чата не доступен',
    })
  } else {
    responseStatus = await store.dispatch('getProfile')

    if (responseStatus === 401) {
      await store.dispatch('authorization')
      await store.dispatch('getProfile')
    }

    return new Echo({
      broadcaster: 'socket.io',
      namespace: '',
      host,
      auth: {
        headers: {
          Authorization: `Bearer ${store.state.plChat.provider.chat.token}`,
        },
      },
    })
  }

  return null
}
